import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';
import { courseDetailDataDefault } from 'utils/valueDefault';

const apiUrl = `${API_URL}/course_detail`;

export const ACTION_TYPES = {
  FETCH_COURSEDETAIL_LIST: 'coursedetail/FETCH_COURSEDETAIL_LIST',
  FETCH_COURSEDETAIL: 'coursedetail/FETCH_COURSEDETAIL',
  CREATE_COURSEDETAIL: 'coursedetail/CREATE_COURSEDETAIL',
  UPDATE_COURSEDETAIL: 'coursedetail/UPDATE_COURSEDETAIL',
  DELETE_COURSEDETAIL: 'coursedetail/DELETE_COURSEDETAIL',
  RESET: 'coursedetail/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [], //ent
  entity: courseDetailDataDefault, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const coursedetailReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_COURSEDETAIL_LIST):
    case REQUEST(ACTION_TYPES.FETCH_COURSEDETAIL):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_COURSEDETAIL):
    case REQUEST(ACTION_TYPES.UPDATE_COURSEDETAIL):
    case REQUEST(ACTION_TYPES.DELETE_COURSEDETAIL):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_COURSEDETAIL_LIST):
    case FAILURE(ACTION_TYPES.FETCH_COURSEDETAIL):
    case FAILURE(ACTION_TYPES.CREATE_COURSEDETAIL):
    case FAILURE(ACTION_TYPES.UPDATE_COURSEDETAIL):
    case FAILURE(ACTION_TYPES.DELETE_COURSEDETAIL):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload.response,
      };
    case SUCCESS(ACTION_TYPES.FETCH_COURSEDETAIL_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_COURSEDETAIL):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_COURSEDETAIL):
    case SUCCESS(ACTION_TYPES.UPDATE_COURSEDETAIL):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
        successMessage: action.payload.meta,
      };
    case SUCCESS(ACTION_TYPES.DELETE_COURSEDETAIL):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default coursedetailReducer;

// ACTIONS
export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_COURSEDETAIL_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_COURSEDETAIL,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const getEntityByCourseID = id => ({
  type: ACTION_TYPES.FETCH_COURSEDETAIL,
  payload: axios.get(`${apiUrl}/course/${id}`),
});

export const createEntity = (entity) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_COURSEDETAIL,
    payload: axios.post(apiUrl, entity)
  });
  return result;
};

export const updateEntity = (entity, id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_COURSEDETAIL,
    payload: axios.patch(`${apiUrl}/${id}`, entity)
  });
  return result;
};

export const deleteEntity = id => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_COURSEDETAIL,
    payload: axios.delete(`${apiUrl}/${id}`)
  });
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
